import { object, string, boolean, number } from 'yup';

export const createSchema = object().shape({
    type: string().required(),
    description: string().required()
});

export const updateSchema = object().shape({

});